import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { InteriorDetailingPage } from './pages/InteriorDetailingPage';
import { ExteriorDetailingPage } from './pages/ExteriorDetailingPage';
import { FullCarDetailPage } from './pages/FullCarDetailPage';
import { CeramicCoatingPage } from './pages/CeramicCoatingPage';
import { PaintCorrectionPage } from './pages/PaintCorrectionPage';
import { HeadlightRestorationPage } from './pages/HeadlightRestorationPage';
export function App() {
  useEffect(() => {
    // Google Analytics (gtag.js)
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-BBSL5F5SDB';
    document.head.appendChild(script);
    const inlineScript = document.createElement('script');
    inlineScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-BBSL5F5SDB');
    `;
    document.head.appendChild(inlineScript);
  }, []);
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/services/interior-detailing" element={<InteriorDetailingPage data-id="element-5" />} data-id="element-4" />
        <Route path="/services/exterior-detailing" element={<ExteriorDetailingPage data-id="element-7" />} data-id="element-6" />
        <Route path="/services/full-car-detail" element={<FullCarDetailPage data-id="element-9" />} data-id="element-8" />
        <Route path="/services/ceramic-coating" element={<CeramicCoatingPage data-id="element-11" />} data-id="element-10" />
        <Route path="/services/paint-correction" element={<PaintCorrectionPage data-id="element-13" />} data-id="element-12" />
        <Route path="/services/headlight-restoration" element={<HeadlightRestorationPage data-id="element-15" />} data-id="element-14" />
      </Routes>
    </BrowserRouter>;
}